const gridColor = "#494A4C";
export const generateCircularYGrid = (chart: any) => {
  const customYAxisLabels = [50, 100, 150, 200, 250, 300, 350]

  const ctx = chart.ctx;
  const yAxis = chart.scales.y;
  const xAxis = chart.scales.x;

  ctx.strokeStyle = gridColor;
  ctx.lineWidth = 1;


  // Draw the rings
  customYAxisLabels.forEach((label) => {
    ctx.beginPath();
    const radius = yAxis.bottom - yAxis.getPixelForValue(label);
    const pixelPositionX0 = xAxis.getPixelForValue(0);
    const pixelPositionY0 = yAxis.getPixelForValue(0);

    ctx.arc(pixelPositionX0, pixelPositionY0, radius, 0, 2 * Math.PI);
    ctx.stroke()

    let labelText = chart?.data?.labels?.length && chart?.data?.labels[0] === "metric" ? `${label}m` : `${label}y`;
    ctx.fillStyle = "#eaecef";
    ctx.font = '18px "Stratos-SemiBold", Helvetica';

    let xPosFromBottom = chart.scales.x.bottom - yAxis.getPixelForValue(label);
    let xPosFromRight = chart.scales.x.right - pixelPositionX0;

    let labelPosFromBottom = 0;
    if (xPosFromBottom*xPosFromBottom > xPosFromRight*xPosFromRight) {
      labelPosFromBottom = Math.sqrt(xPosFromBottom*xPosFromBottom - xPosFromRight*xPosFromRight);
    }

    let textXPosition = chart.scales.x.right - 42;
    if (labelPosFromBottom === 0 ) {
      textXPosition = chart.scales.x.right - pixelPositionX0 + xPosFromBottom;
    }
    let textYPosition = chart.scales.x.bottom - labelPosFromBottom;

    ctx.fillText(labelText, textXPosition, textYPosition);
  });
}

export const generateCenterXGrid = (chart: any) => {
  const ctx = chart.ctx;
  const yAxis = chart.scales.y;
  const xAxis = chart.scales.x;
  ctx.strokeStyle = gridColor;
  ctx.beginPath();
  const pixelPositionX0 = xAxis.getPixelForValue(0);
  ctx.moveTo(pixelPositionX0, yAxis.top - 100); // Start at the top
  ctx.lineTo(pixelPositionX0, yAxis.bottom + 100); // End at the bottom
  ctx.stroke();
}